export const amyloidStatusOptions = 'Select an Amyloid status, Ab+, Ab-, Not yet determined'.split(',');
